const defaultCode = 'YCTN2619HDQA';

export const jrAccountCodes = {
    defaults: () => [defaultCode],
    normalize(value) {
        const values = Array.isArray(value) ? value : [value];
        return [...new Set(values.flatMap(entry => typeof entry === 'string'
            ? entry.split(',').map(code => code.trim().toUpperCase()).filter(Boolean)
            : []))];
    },
    error(codes) {
        if (codes.some(code => !/^[A-Z0-9]{1,32}$/.test(code))) {
            return 'Use letters and numbers only, up to 32 characters per code.';
        }
        return codes.length > 25 ? 'Use at most 25 account codes.' : '';
    },
    label(value) {
        return jrAccountCodes.normalize(value === undefined ? defaultCode : value).join(', ') || '(none)';
    },
    methods: {
        accountCodesLabel: value => jrAccountCodes.label(value),
        setAccountCodes(value) {
            const codes = jrAccountCodes.normalize(value);
            this.jrmask.options.account_code = codes;
            this.accountCodeError = jrAccountCodes.error(codes);
        },
        clearAccountCodeSearch() {
            this.accountCodeSearch = '';
            // VCombobox exposes its internal search ref; clearing the parent alone
            // does not clear the typed text in the installed Vuetify version.
            if (this.$refs?.accountCodes) this.$refs.accountCodes.search = '';
        },
        commitAccountCodes() {
            this.setAccountCodes([
                ...jrAccountCodes.normalize(this.jrmask.options.account_code),
                this.accountCodeSearch || '',
            ]);
            this.clearAccountCodeSearch();
        },
        accountCodeKeydown(event) {
            if (event.isComposing || !['Enter', ','].includes(event.key)) return;
            event.preventDefault();
            event.stopPropagation();
            this.commitAccountCodes();
        },
        pasteAccountCodes(event) {
            const text = event.clipboardData?.getData('text') || '';
            const input = event.target;
            const current = input.value || this.accountCodeSearch || '';
            this.accountCodeSearch = current.slice(0, input.selectionStart ?? current.length)
                + text + current.slice(input.selectionEnd ?? current.length);
            this.commitAccountCodes();
        },
        prepareAccountCodes() {
            const codes = jrAccountCodes.normalize([
                ...jrAccountCodes.normalize(this.jrmask.options.account_code),
                this.accountCodeSearch || '',
            ]);
            this.accountCodeError = jrAccountCodes.error(codes);
            if (this.accountCodeError) return false;
            this.jrmask.options.account_code = codes;
            this.clearAccountCodeSearch();
            return true;
        },
    },
};
